import classNames from 'classnames';
import React from 'react';

interface UnderlayProps {
  isOpen?: boolean;
}

export const Underlay = ({ isOpen }: UnderlayProps) => {
  return <div className={classNames('underlayStyles', { 'is-open-class': isOpen })} />;
};
